<div class="modal-header">
  <h4 class="modal-title">{{ 'editArticleMaterials.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner pt-2">
    <p>{{ 'editArticleMaterials.label.description' | translate }}</p>

    <table formValidator (formValid)="allColorsValid.set($event)" class="table table-sm table-striped">
      <thead>
      <tr>
        <th>{{ 'editArticleMaterials.label.color' | translate }}</th>
        <th>{{ 'editArticleMaterials.label.opacity' | translate }}</th>
      </tr>
      </thead>
      <tbody>
        @for (material of materialsInfo(); track $index) {
          <tr>
            <td class="d-flex ps-2">
              <div class="d-flex flex-column me-2">
                <input [(ngModel)]="material.colorToUse" [validator]="hexValidator" style="width: 180px" type="text" class="form-control">
              </div>
              <input [(ngModel)]="material.colorToUse" type="color" class="form-control form-control-color"></td>
            <td><input [(ngModel)]="material.opacityToUse" type="number" step="0.01" min="0" max="1"></td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="cancel()">{{ 'global.label.cancel' | translate }}</button>
  <button class="btn btn-primary btn-forward" [disabled]="!allColorsValid()" (click)="applyMaterialChanges()">{{ 'global.label.accept' | translate }}</button>
</div>
